import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { storeEmployeeType } from '../services'
import { handleError } from '../../../helpers'
import { message } from 'antd'
import EmployeeTypeForm from './EmployeeTypeForm'

export default function NewEmployeeTypeModal({ visible, onClose, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm()

	const onSubmit = values => {
		storeEmployeeType(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(handleError)
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Agregar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<EmployeeTypeForm 
						register={register}
						errors={errors}
					/>
					<Button color='primary' type="submit">
						Agregar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}